import useAnalytics from './useAnalytics';
import useOrgChartSettings from 'pages/OrgChart/helpers/useOrgChartSettings';

function useOrgChartAnalytics(event: string) {
  const analytics = useAnalytics();
  const { view, cardStyle } = useOrgChartSettings();

  return () =>
    analytics.track(event, {
      category: 'OrgChart',
      orgChartView: view,
      cardStyle: cardStyle,
    });
}

export default useOrgChartAnalytics;
